<script>
  import { fly } from 'svelte/transition'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()
  const close = () => dispatch('close')

  const handle_keydown = (e) => {
    if (e.key === 'Escape') {
      close()
      return
    }
  }
</script>

<svelte:window on:keydown|capture|stopPropagation={handle_keydown} />
<div
  class="modal"
  aria-modal="true"
  transition:fly={{ duration: 300, y: -300 }}>
  <div class="content-wrapper">
    <slot />
  </div>
</div>

<style lang="scss">
  @import '../responsive.scss';

  body.modal {
    overflow-y: hidden;
  }

  .modal {
    position: fixed;
    top: 60px;
    padding: 1em 3em 0 3em;
    width: 100vw;
    min-height: 100vh;
    background: var(--light);
    z-index: 4;

    @include for-phone {
      top: 40px;
      padding: 1em 1em 0 1em;
    }
  }
</style>
